if(!customElements.get('tile-selector-widget')) {
  
  class TileSelectorWidget extends HTMLElement {
    constructor() {
      super();
      console.log('TileSelectorWidget constructor called');
      setTimeout(() => {
        this.initView();
      }, 500);
    }

    initView() {
      this.searchButton = this.querySelector('button');
      this.searchButton.addEventListener('click', this.handleSearch.bind(this));
      
      // Initialize dropdown functionality
      this.initDropdowns();
      this.setupOutsideClickListener();
    }

    handleSearch(evt) {
      console.log('Search button clicked');
    }

    initDropdowns() {
      // Add click listeners to all dropdown headers
      const dropdownHeaders = this.querySelectorAll('.dropdown-header');
      dropdownHeaders.forEach(header => {
        header.addEventListener('click', this.toggleDropdown.bind(this));
      });
    }

    toggleDropdown(event) {
      const header = event.currentTarget;
      const filterGroup = header.parentElement;
      const isCurrentlyOpen = filterGroup.classList.contains('open');
      
      // Close all other dropdowns within this widget
      this.querySelectorAll('.filter-group.open').forEach(group => {
        if (group !== filterGroup) {
          group.classList.remove('open');
        }
      });
      
      // Toggle current dropdown
      filterGroup.classList.toggle('open');
    }

    setupOutsideClickListener() {
      // Close dropdowns when clicking outside this widget
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) {
          this.querySelectorAll('.filter-group.open').forEach(group => {
            group.classList.remove('open');
          });
        }
      });
    }

    // Method to get selected values for each filter
    getSelectedFilters() {
      const filters = {};
      const filterGroups = this.querySelectorAll('.filter-group');
      
      filterGroups.forEach(group => {
        const checkboxes = group.querySelectorAll('input[type="checkbox"]:checked');
        if (checkboxes.length > 0) {
          const filterName = checkboxes[0].name;
          filters[filterName] = Array.from(checkboxes).map(cb => cb.value);
        }
      });
      
      return filters;
    }

    // Method to close all dropdowns (useful for external control)
    closeAllDropdowns() {
      this.querySelectorAll('.filter-group.open').forEach(group => {
        group.classList.remove('open');
      });
    }
  }

  customElements.define('tile-selector-widget', TileSelectorWidget);
}